// Keep in sync with haazri-api/constants/permissions.js. The API is the real
// gatekeeper; these only decide what the portal shows.
export const PERMISSIONS = {
  DASHBOARD: "dashboard",
  REQUESTS: "requests",
  REQUESTS_DECIDE: "requests.decide",
  REPORTS_GENERAL: "reports.general",
  REPORTS_LEAVE_WFH: "reports.leave_wfh",
  REPORTS_TRAVEL_ALLOWANCE: "reports.travel_allowance",
  REPORTS_UNRESOLVED_COMMENTS: "reports.unresolved_comments",
  SETTINGS_PUBLIC_HOLIDAYS: "settings.public_holidays",
  GOALS: "goals",
  USERS_MANAGE: "users.manage",
  EMPLOYEES_MANAGE: "employees.manage",
  ASSETS_MANAGE: "assets.manage",
};

const ALL_PERMISSIONS = "*";

export const hasPermission = (granted, required) =>
  Array.isArray(granted) && (granted.includes(ALL_PERMISSIONS) || granted.includes(required));

// A route with `nested` children is reachable if any child is; a route with no
// `permission` is open to every signed-in admin.
export const canAccessRoute = (route, granted, admin = null) => {
  if (route.nested) {
    return route.nested.some((child) => canAccessRoute(child, granted, admin));
  }
  // Platform admin is a flag on the account, not a role permission, so even a
  // Super Admin ("*") doesn't get these pages.
  if (route.platformAdminOnly) return !!admin?.is_platform_admin;
  // Super Admin-only pages (e.g. Roles): the all-features role, or a platform admin.
  if (route.superAdminOnly && !(admin?.is_super_admin || admin?.is_platform_admin)) return false;
  return !route.permission || hasPermission(granted, route.permission);
};

// Where to send an admin who lands somewhere they can't access.
export const getFirstAccessiblePath = (routes, granted, admin = null) => {
  const first = routes.find(
    (route) => route.type === "collapse" && canAccessRoute(route, granted, admin)
  );
  if (!first) return null;
  const child = first.nested && first.nested.find((c) => canAccessRoute(c, granted, admin));
  return child ? `${first.route}/${child.path}` : first.route;
};
